export default __webpack_public_path__ + "static/111-1762be88dbb2ed9be511bb95edfb8684.jpg";